import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../../../../shared/services/auth.service';
import { UserInfo } from '../../../../../../shared/models/user-info';
import { environment } from '../../../../../../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrl: './my-account.component.scss'
})
export class MyAccountComponent implements OnInit {
  userInfo: UserInfo | null = null;
  isLogin: boolean = false;
  isAdmin: Boolean = false;

  constructor(private translate: TranslateService, private authService: AuthService, private router: Router) { 
    translate.setDefaultLang('fr');
  }

  ngOnInit(): void {
    
    this.authService.getUserInfo().subscribe(userInfo => {
      this.userInfo = userInfo;
      this.isLogin = !!userInfo; 
      this.isAdmin = this.authService.isAdmin();
    });
  }

  switchLanguage(language: string) {
    this.translate.use(language);
  }

  loginUser() {
    this.authService.login();
  }

  logout(){
    this.authService.logout();
  }

  goToAdmin(): void {
    this.router.navigate(['/admin']);
  }

  editPassword(){
    this.authService.changePassword()
  }

}
